import React, { useEffect, useState } from "react"
import { appConstants } from "../../../../../constants/app_constants"
import { Link, useNavigate } from "react-router-dom"
import SmallLoader from "../../../../Common/SmallLoader";

const Verfied = ({ isLoggedIn, redirectToLogin, loading }) => {
  const [timeLeft, setTimeLeft] = useState(5);
  const navigate = useNavigate();
  const [clicked, setClicked] = useState(false)

  const handleClick = () => {
    setClicked(true)
  }

  useEffect(() => {
    if (isLoggedIn && clicked) {
      redirectToLogin();
    }
  }, [isLoggedIn, clicked])
  useEffect(() => {
    // Only start the countdown if there's time left
    if (timeLeft > 0) {
      const timerId = setInterval(() => {
        setTimeLeft(prevTime => prevTime - 1);
      }, 1000);

      // Cleanup the interval on component unmount or when timer ends
      return () => clearInterval(timerId);
    }
    else {
      setTimeout(() => {
        navigate("/dashboard")
      }, 1000)

    }
  }, [timeLeft]);

  return (
    <div className="password-update-sub-container">
      <div className="common-margin sub-text-verified">
        You will be automatically re-directed <br />
        to the {appConstants.cName} dashboard in <span className="link">{timeLeft} sec</span>

      </div>
      <button
        className={`background-button`}
        onClick={handleClick}
      > {clicked ? <SmallLoader /> : "Take me to dashboard"}

      </button>

    </div>

  )
}

export default Verfied
